module.exports = __webpack_public_path__ + "media/images/upload-new-b2e2d0b5.png";